import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import classNames from 'classnames'
// Components
import { Text, Logo } from '../../..'
import ContactInfo from './ContactInfo/ContactInfo'
// Styles
import styles from './FooterText.module.scss'

const currentYear = format(new Date(), 'yyyy')

const propTypes = {
  className: PropTypes.string,
}

export interface FooterTextProps {
  className: string
}

const FooterText = ({ className }: FooterTextProps) => (
  <div className={className} data-qa='homebot-disclaimer'>
    <Text
      paragraph
      size='m'
      variant='neutralCool'
      variantCount='700'
      element='div'
    >
      <p>
        <FormattedMessage
          id='Footer.copyright'
          defaultMessage='© {currentYear} Homebot Inc. All rights reserved.'
          values={{ currentYear }}
        />
      </p>

      <p>
        <FormattedMessage
          id='Footer.trademark'
          defaultMessage='Homebot™ and the Homebot logo are trademarks of Homebot Inc.'
        />
      </p>

      <p>
        <FormattedMessage
          id='Footer.unaffiliatedShort'
          defaultMessage='Homebot is an unaffiliated business party.'
        />
      </p>

      <p>
        <FormattedMessage
          id='Footer.purchasedByUs'
          defaultMessage='Homebot is a service purchased by us to provide to you, our customer.'
        />
      </p>
    </Text>
    <Logo className={classNames(styles.logo, styles.forceShow)} />

    <ContactInfo />
  </div>
)

FooterText.propTypes = propTypes

export default FooterText
